import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useGetCatalog } from '~/pages/pay/hooks/useGetCatalog';
import { Halo } from '~/shared/ui/Halo/Halo.ui';

import { useLocalization } from '../../../../localization/localization';
import { Divider } from '../../Divider/Divider';
import { ErrorCard } from '../SelectProductStep/components/ErrorPricesCard/ErrorPricesCard';

import { Header, Main, Root } from './SelectCertificateStep.ui';
import { CardList } from './components/CardsList/CardsList';
import { Loader } from './components/Loader/Loader';
import { SearchInput } from './components/SearchInput/SearchInput';

export const SelectCertificateStep = () => {
  const [filter, setFilter] = useState('');
  const { t } = useLocalization();
  const { setValue } = useFormContext();

  const { certificates, loading, isError } = useGetCatalog();

  useEffect(() => {
    setValue('offer', false);
    setValue('product', undefined);
    setValue('certificate', undefined);
  }, [setValue]);

  const certificatesFiltered = certificates.filter(({ brand }) =>
    brand?.title?.toLowerCase().includes(filter.toLowerCase()),
  );

  return (
    <Root>
      <Header>
        <SearchInput onChange={setFilter} />
      </Header>
      <Main>
        <Halo aria-hidden="true" />
        {isError ? (
          <ErrorCard
            title={t('Error catalog title')}
            description={t('Error catalog description')}
          />
        ) : (
          <>
            <Divider title={t('Select what you want to top up')} />
            {loading ? (
              <Loader />
            ) : (
              <CardList certificates={certificatesFiltered} />
            )}
          </>
        )}
      </Main>
    </Root>
  );
};
